import { ScrollableContent } from "@homebound/beam";
import { HistoryFeed } from "src/components";
import { useCostCodeHistoryQuery } from "src/routes/admin/costCodes/CostCodeHistoryTab.generated";
import { queryResult } from "src/utils";

export function CostCodeHistoryTab({ costCodeId }: { costCodeId: string }) {
  const query = useCostCodeHistoryQuery({ variables: { costCodeId } });
  return queryResult(query, {
    data: ({ costCodes }) => (
      <ScrollableContent>
        <HistoryFeed historyItems={costCodes.first?.history ?? []} />
      </ScrollableContent>
    ),
  });
}
